module.exports = __webpack_public_path__ + "static/media/worship_venue.6996ca06.svg";